module.exports = __webpack_public_path__ + "49ff6f6b50ce45d0ff0497a4e4e86f4f.png";